/* eslint-disable prettier/prettier */

export const primary950 = 'rgb(28, 14, 13)';
export const primary900 = 'rgb(40, 17, 17)';
export const primary800 = 'rgb(54, 32, 32)';
export const primary750 = 'rgb(62, 40, 40)';
export const primary700 = 'rgb(70, 47, 47)';
export const primary600 = 'rgb(87, 59, 59)';
export const primary500 = 'rgb(105, 74, 74)';
export const primary450 = 'rgb(119, 88, 88)';
export const primary400 = 'rgb(133, 101, 101)';
export const primary300 = 'rgb(162, 132, 132)';
export const primary200 = 'rgb(192, 166, 166)';
export const primary100 = 'rgb(223, 204, 205)';
export const primary50  = 'rgb(242, 233, 233)';

export const ink700 = 'rgb(45, 42, 43)';
export const ink600 = 'rgb(61, 56, 57)';
export const ink500 = 'rgb(81, 75, 76)';
export const ink400 = 'rgb(106, 99, 100)';
export const ink300 = 'rgb(137, 130, 131)';
export const ink200 = 'rgb(175, 170, 171)';
export const ink100 = 'rgb(215, 212, 213)';
export const ink75  = 'rgb(228, 225, 226)';
export const ink50  = 'rgb(240, 238, 238)';
export const ink25  = 'rgb(248, 247, 247)';

export const coral700 = 'rgb(184, 69, 56)';
export const coral600 = 'rgb(207, 77, 65)';
export const coral500 = 'rgb(234, 99, 84)';
export const coral400 = 'rgb(239, 133, 121)';
export const coral300 = 'rgb(242, 169, 156)';
export const coral200 = 'rgb(247, 204, 196)';
export const coral100 = 'rgb(249, 221, 211)';
export const coral50  = 'rgb(253, 242, 240)';

export const gold700 = 'rgb(115, 78, 30)';
export const gold600 = 'rgb(149, 100, 39)';
export const gold500 = 'rgb(175, 125, 60)';
export const gold400 = 'rgb(203, 154, 86)';
export const gold300 = 'rgb(223, 191, 145)';
export const gold200 = 'rgb(236, 215, 181)';
export const gold100 = 'rgb(246, 233, 213)';
export const gold50  = 'rgb(252, 245, 235)';

export const neutral900 = 'rgb(25, 23, 24)';
export const neutral800 = 'rgb(38, 34, 35)';
export const neutral700 = 'rgb(55, 51, 52)';
export const neutral600 = 'rgb(75, 71, 73)';
export const neutral550 = 'rgb(94, 90, 91)';
export const neutral500 = 'rgb(112, 109, 109)';
export const neutral400 = 'rgb(147, 147, 145)';
export const neutral300 = 'rgb(184, 185, 182)';
export const neutral200 = 'rgb(214, 215, 212)';
export const neutral150 = 'rgb(227, 228, 225)';
export const neutral100 = 'rgb(238, 239, 236)';
export const neutral50  = 'rgb(247, 247, 246)';

// TODO

export const statusGreenBg = 'rgb(240, 247, 242)';
export const statusGreenFg = 'rgb(82, 137, 97)';

export const statusYellowBg = 'rgb(252, 246, 235)';
export const statusYellowFg = 'rgb(148, 99, 39)';

export const statusRedBg = 'rgb(253, 243, 238)';
export const statusRedFg = 'rgb(207, 77, 64)';

export const statusBlueBg = 'rgb(238, 244, 248)';
export const statusBlueFg = 'rgb(85, 121, 152)';

export const textOnDarkMuted = 'rgba(255, 255, 255, 0.55)';

export const white = 'rgb(255, 255, 255)';
